let resultsTpl = require('./results.tpl.html');

class ResultsController {
    constructor($equalOneUIService, $translate) {
        var ctrl = this;
        ctrl.equalOneUIService = $equalOneUIService;
        ctrl.$translate = $translate;
        ctrl.resultTitle = this.$translate.instant("app.results.results");

        ctrl.showChart = function(link) {
            ctrl.onShowChart({link: link});
        }
    }
}

ResultsController.$inject = ['EQualOneUIService', '$translate'];

let Results = {
    bindings: {
        testResults: "=",
        onShowChart: "&"
    },
    templateUrl: resultsTpl,
    controller: ResultsController
};

export default Results;


// WEBPACK FOOTER //
// ./src/equalone-ui/components/results/results.component.js